module.exports = __webpack_public_path__ + "img/mobile-51.6acc50cd.png";